<template>
  <div class="zSteps">
    <div :class="prefixCls + '-common'">
      <Row type="flex" justify="center" align="middle">
        <Col span="1" class="item-col">
          <span class="icon" :class="step >= 1 ? activeClass: ''">
            <i class="iconfont icon-step5"></i>
          </span>
          <p class="txt">填写订单信息</p>
        </Col>
        <Col span="10" class="col-span" :class="step > 1 ? activeLine : ''">
          <span class="line" :class="step >= 1 ? activeClass: ''"></span>
        </Col>

        <Col span="1" class="item-col">
          <span class="icon" :class="step >= 2 ? activeClass: ''">
            <i class="iconfont icon-step4"></i>
          </span>
          <p class="txt">确认合同</p>
        </Col>
        <Col span="10" class="col-span" :class="step > 2 ? activeLine : ''">
          <span class="line" :class="step >= 2 ? activeClass: ''"></span>
        </Col>

        <Col span="1" class="item-col">
          <span class="icon" :class="step >= 3 ? activeClass: ''">
            <i class="iconfont icon-step3"></i>
          </span>
          <p class="txt">支付</p>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
const prefixCls = "zSteps";
export default {
  name: "ZSteps",
  data() {
    return {
      prefixCls: prefixCls
    };
  },
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  computed: {
    activeClass() {
      return `${this.prefixCls}-active`;
    },
    activeLine() {
      return `${this.prefixCls}-line`;
    }
  }
};
</script>

